import styled from "styled-components";

export const Heading = styled("h1")`
  font-size: 2.5em;
  font-weight: 800;
  margin: 1em 0;
  font-family: "Montserrat", sans-serif !important;
  @media (max-width: 992px) {
    & {
      font-size: 2em;
    }
  }
  @media (max-width: 786px) {
    & {
      font-size: 1.2em !important;
    }
  }
`;
export const OrderNumContainer = styled("div")`
  width: 100%;
  margin-top: 6em;
  height: 70vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media (max-width: 768px) {
    & {
      height: 100%;
    }
  }
`;
export const OrderNum = styled("div")`
  width: 100%;
  /* background-color: lightblue; */
  display: flex;
  flex-direction: column;
  -webkit-box-pack: center;
  justify-content: end;
  -webkit-box-align: center;
  align-items: center;
  line-height: 0.7;
  margin: 2em auto;
  div {
    width: 300px !important;
    height: 300px !important;
  }
  h1 {
    font-size: 3em;
    margin-bottom: 0em;
  }
  h2 {
    font-size: 13em;
    margin-bottom: 0.2em;
    line-height: 1;
    font-family: "Helvetica-light";
  }
  @media (max-width: 768px) {
    & {
      div {
        width: 100px !important;
        height: 100px !important;
      }
      margin-top: 35px;
      h1 {
        font-size: 1.2em;
      }
      h2 {
        font-size: 5.7em;
      }
    }
  }
  @media (max-width: 470px) {
    & {
      div {
        width: 100px !important;
        height: 100px !important;
      }
      margin-top: 35px;
      h1 {
        font-size: 1.2em;
      }
      h2 {
        font-size: 5.7em;
      }
    }
  }
`;
export const Receipt = styled("div")`
  text-align: center;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin: 0.3em auto.
  align-items: center;

  h4 {
    line-height: 1;
    font-size: 3.5em;
    margin-bottom: 0em;
  }
  h3 {
    line-height: 1;
    font-size: 4.5em;
    font-family: "Helvetica-light";
    margin-bottom: 0em;
  }
  h1 {
    line-height: 1;
    font-size: 5em;
    margin-bottom: 0.5em;
  }
  @media (max-width: 768px) {
    & {
      h1 {
        font-size: 2.5em;
      }
      h3 {
        margin-top: 0.1em;
        font-size: 2.2em !important;
      }
      h4 {
        font-size: 1.7em;
      }
    }
  }
`;
export const QRCode = styled("div")`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  /* background-color: lightcyan; */
  .closeIcon {
    div {
      width: 300px !important;
      height: 300px !important;
    }
  }
  @media (max-width: 768px) {
    & {
      .closeIcon {
        div {
          width: 130px !important;
          height: 130px !important;
        }
      }
    }
  }
`;
export const QRCodeContainer = styled("div")`
  width: 326px;
  height: 308px;
  background-color: #e2dac6;
  border-radius: 15pt;
  display: flex;
  justify-content: center;
  align-items: center;

  .imgstyle {
    width: 200px;
    height: 200px;
  }
  @media (max-width: 768px) {
    & {
      width: 120px;
      height: 120px;
      .imgstyle {
        width: 95px;
        height: 95px;
      }
    }
  }
`;
